export default "__VITE_ASSET__6c9663da__"